const passkey_sign_in = {
    setup_page: {
        title: 'Simplifique o seu início de sessão',
        subtitle: 'Crie uma chave de acesso',
        description: 'Registe a sua chave de acesso utilizando a biometria do dispositivo, chaves de segurança como a YubiKey ou outros métodos disponíveis.',
    },
    trigger_conditional_ui_failed: 'Falha ao acionar o preenchimento automático com passkey.',
};
export default Object.freeze(passkey_sign_in);
